module.exports = __webpack_public_path__ + "img/limit-permission.c178761.png";